import { UseFormReturn } from "react-hook-form";
import CheckoutShippingAddressForm from "@shared/modules/checkout/components/delivery-methods/CheckoutShippingAddressForm/CheckoutShippingAddressForm.web";
import Box from "@shared/components/ui-kit/layout/Box/Box.web";

function PublicCheckoutShippingAddressForm({
  form,
  allowedCountries,
}: {
  form: UseFormReturn;
  // TODO: this should be a required prop since public checkouts should always check for allowed countries
  // update when CheckoutAcceptTransfer is updated
  allowedCountries?: string[] | null;
}) {
  return (
    <Box>
      <CheckoutShippingAddressForm
        form={form}
        allowedCountries={allowedCountries}
      />
    </Box>
  );
}

export default PublicCheckoutShippingAddressForm;
